import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
    providedIn: "root",
})
export class FormService {

    desiredRoleValidator(validRoles: string[]): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            return validRoles.includes(value) ? null : { invalidRole: true };
        };
    }

    passwordValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value || '';
            const hasUpperCase = /[A-Z]/.test(value);
            const hasLowerCase = /[a-z]/.test(value);
            const hasNumeric = /[0-9]/.test(value);
            const isValidLength = value.length >= 6;
            const passwordValid = hasUpperCase && hasLowerCase && hasNumeric && isValidLength;

            return !passwordValid ? { passwordInvalid: true } : null;
        };
    }
}